exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-components-___Footer__footer___CYghd{margin-top:2em;display:flex;flex-direction:row-reverse;justify-content:space-between}.web-components-___Footer__border___1ESYf{border-top:1px solid #e5e3e3;padding-top:1em}", ""]);

// exports
exports.locals = {
	"footer": "web-components-___Footer__footer___CYghd",
	"border": "web-components-___Footer__border___1ESYf"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/components/Footer.css
// module id = 1330
// module chunks = 0